module.exports = __webpack_public_path__ + "img/1525768713.485340a1.jpg";